import { i18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";

import type {
  VoiceNotice,
  VoiceSessionContext,
} from "../../voice/voiceSessionMachine.ts";

/*
 * What a voice session is doing, in words. Shown as the composer's placeholder
 * and announced to screen readers; the dot carries the same states in motion.
 */

export function statusLabel(state: VoiceSessionContext["state"]): string {
  switch (state) {
    case "listening":
      return i18n._(
        msg({
          message: "Listening",
          context: "Voice mode status while the microphone is open",
        }),
      );
    case "transcribing":
      return i18n._(
        msg({
          message: "Got that",
          context: "Voice mode status while speech is being transcribed",
        }),
      );
    case "thinking":
      return i18n._(
        msg({
          message: "Thinking",
          context: "Voice mode status while Tally works out the answer",
        }),
      );
    case "speaking":
      return i18n._(
        msg({
          message: "Speaking",
          context: "Voice mode status while Tally reads the answer aloud",
        }),
      );
    default:
      return "";
  }
}

export function noticeLabel(notice: VoiceNotice): string {
  switch (notice) {
    case "not_understood":
      return i18n._(
        msg({
          message: "I did not catch that. Try again.",
          context: "Voice mode hint after an unintelligible recording",
        }),
      );
    case "still_there":
      return i18n._(
        msg({
          message: "Still there?",
          context: "Voice mode hint after a silent listening round",
        }),
      );
    case "transcription_failed":
      return i18n._(
        msg({
          message: "I could not hear that. Try again.",
          context: "Voice mode hint after transcription failed",
        }),
      );
    case "answer_failed":
      return i18n._(
        msg({
          message: "Something went wrong. Ask me again.",
          context: "Voice mode hint after the answer failed",
        }),
      );
    case "playback_failed":
      return i18n._(
        msg({
          message: "I could not play that aloud. The answer is on screen.",
          context: "Voice mode hint after audio playback failed",
        }),
      );
    case "mic_failed":
      return i18n._(
        msg({
          message: "I cannot reach your microphone.",
          context: "Voice mode hint when microphone access fails",
        }),
      );
    default:
      return "";
  }
}
